import React, { useEffect, useState } from 'react'
import * as amplitude from '@amplitude/analytics-browser'
import './index.css'


import tgButton from '../../assets/images/tg-btn-large.png'
import close from '../../assets/images/popup-close.png'
interface IResult {
  error?: AxiosError
  data: IOperationData
  success?: boolean
}

import { enc, HmacSHA256 } from 'crypto-js'
import {AxiosError} from 'axios'
import {IOperationData} from '../../api/types'

const TelegramPopup = ({data}: IResult) => {
  const [isOpen, setIsOpen] = useState(true)
  const [superBotUrl, setSuperBotUrl] = useState<string | null>(null)

  const convertSignature = (data: string) => {
    const secretKey = 'pC4VO23TfC20UsyK1SzbydrZJ'

    if (!secretKey) {
      throw new Error('REACT_APP_SECRET_KEY is not defined')
    }

    return HmacSHA256(data, secretKey).toString(enc.Hex)
  }

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    const fetchData = async () => {

      if (data) {
        try {
          const botsRequestData = {
            transaction_id: data.transaction_id,
            signature: convertSignature(JSON.stringify({
              transaction_id: data.transaction_id
            }))
          }

          const response = await fetch('https://24betting.com/api/v1/telegram/user/bind-link-by-transaction', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(botsRequestData)
          })

          if (!response.ok) {
            console.log('error')
            throw new Error(`HTTP error! status: ${response.status}`)
          }

          const result = await response.json()
          if (result) {
            setSuperBotUrl(result.bind_link)
          }
        } catch (error: any) {
          console.log('error', error)
        }
      }
    }

    fetchData()
  }, [])

  const openSuperBot = () => {
    if (superBotUrl) {
      Promise.resolve(amplitude.track('Click Telegram Notify')).then(() => {
        window.location.href = superBotUrl
      })
    }
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  if (!isOpen || !superBotUrl) return null
  return (
    <div className="telegram-popup">
      <div className="popup-container">
        <img className="popup-close-img" src={close} alt="Close" onClick={handleClose}/>
        <div className="popup-text-large" style={{whiteSpace: 'nowrap'}}>🔥Get 10% Cashback</div>
        <div className="popup-text-large">on Every Deposit!</div>
        <div className="popup-text-medium">Deposit via <span className="popup-span">Telegram App </span>
          or
        </div>
        <div className="popup-text-medium" style={{marginTop: 0}}>
          <span className="popup-span"> 24betting.com</span> and get 10% extra on each payment!
        </div>
        <img className="popup-tg-btn" src={tgButton} alt="Join Telegram" onClick={openSuperBot}/>
      </div>
    </div>
  )
}
export default TelegramPopup
